<template>
  <div>
    <v-row>
      <v-col class="py-0 pt-1" align="center">
        <v-radio-group v-model="selectedDateType" hide-details :disabled="disabled" @change="input">
          <label> {{ label }} </label>
          <v-radio v-for="option in dateTypeOptions" :key="option.value" :label="option.label" :value="option.value">
            <template v-slot:label>
              <span>
                {{ option.label }}
              </span>
            </template>
          </v-radio>
        </v-radio-group>
      </v-col>
    </v-row>
    <v-row>
      <v-col v-if="selectedDateType == 'fixed_range'" class="py-0 pt-3" align="center">
        <mf-date-range-picker
          label="De - Até"
          :initial-date.sync="initDate"
          :final-date.sync="endDate"
          hide-details
          icon
          @update:initialDate="input(true)"
          @update:finalDate="input(false)"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col v-if="selectedDateType == 'dynamic_range'" class="py-0 pt-3" align="center">
        <v-select
          v-model="selectedDynamicPeriod"
          :items="dynamicPeriodOptions"
          :disabled="disabled"
          item-text="label"
          item-value="value"
          class="input-select default-input"
          hide-details=""
          solo
          @change="input"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { DateTime } from 'luxon'

export default {
  components: {},
  props: {
    values: {},
    label: String,
    currentIndex: Number,
    initialValue: {},
    tooltip: String,
    subtitle: String,
    disabled: {
      type: Boolean,
      default: false,
    },
    componentParams: {
      type: Object,
    },
  },
  data: () => ({
    initDate: '',
    endDate: '',
    selectedDateType: 'dynamic_range',
    selectedDynamicPeriod: '',
  }),

  computed: {
    dateTypeOptions() {
      return [
        ...(this.showRadioOption('dynamic_range')
          ? [
              {
                label: 'Período dinâmico',
                value: 'dynamic_range',
              },
            ]
          : []),
        ...(this.showRadioOption('fixed_range')
          ? [
              {
                label: 'Período fixo',
                value: 'fixed_range',
              },
            ]
          : []),
        ...(this.showRadioOption('empty_range')
          ? [
              {
                label: 'Desde o início',
                value: 'empty_range',
              },
            ]
          : []),
      ]
    },
    dynamicPeriodOptions() {
      return this.componentParams.dynamicPeriods
    },
  },

  mounted() {
    if (this.initialValue) {
      this.selectedDateType = this.initialValue.type
      if (this.selectedDateType === 'dynamic_range') {
        this.selectedDynamicPeriod = this.initialValue.value
      } else if (this.selectedDateType === 'fixed_range') {
        this.initDate = this.initialValue.value?.[0] ? DateTime.fromFormat(this.initialValue.value?.[0], 'yyyyMMdd').toFormat('yyyy-MM-dd') : ''
        this.endDate = this.initialValue.value?.[1] ? DateTime.fromFormat(this.initialValue.value?.[1], 'yyyyMMdd').toFormat('yyyy-MM-dd') : ''
      }
    } else {
      this.selectedDateType = 'dynamic_range'
      this.selectedDynamicPeriod = this.dynamicPeriodOptions[0].value
      this.input()
    }
    this.validate()
  },

  methods: {
    showRadioOption(type) {
      if (!this.componentParams?.hide?.length) return true
      return !this.componentParams?.hide.includes(type)
    },
    input(isInitialDate) {
      if (isInitialDate === 'boolean' && isInitialDate) return
      const currentChildren = this.values?.[0]
      let currentValue = {
        type: this.selectedDateType,
      }
      if (this.selectedDateType === 'dynamic_range') {
        currentValue.value = this.selectedDynamicPeriod
        currentValue.text = this.dynamicPeriodOptions.find((option) => option.value === this.selectedDynamicPeriod).text
      } else if (this.selectedDateType === 'fixed_range') {
        currentValue.value = [DateTime.fromISO(this.initDate).toFormat('yyyyMMdd'), DateTime.fromISO(this.endDate).toFormat('yyyyMMdd')]
      }

      this.$emit('input', { currentValue, currentChildren, currentIndex: this.currentIndex })

      this.validate()
    },

    validate() {
      this.$emit('validate', { isValid: true, currentIndex: this.currentIndex })
    },
  },
}
</script>

<style lang="scss">
.criterio-radio-button {
  .v-input {
    margin-top: 0;
  }
}
</style>
